import React from 'react';
import { useAccount } from 'wagmi';
import { RefreshCw } from 'lucide-react';
import ConnectButton from "../components/Wallet/ConnectButton";
import TransactionHistory from "../components/Bridge/TransactionHistory";
import { useBridgeHistory } from "../hooks/useBridgeHistory";
import { useBridgeNetworkKey } from "../hooks/useBridgeNetworkKey";

export default function HistoryPage() {
  const { address } = useAccount();
  const selectedNetwork = useBridgeNetworkKey();

  const {
    mintDepositAddresses,
    burnHistory,
    isLoading,
    refreshHistory,
  } = useBridgeHistory(selectedNetwork);

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-dark-100 mb-4">Transaction History</h1>
        <p className="text-dark-400">
          View your wrap and unwrap transaction history across all supported networks
        </p>
      </div>

      <div className="mb-8 flex justify-center">
        <ConnectButton />
      </div>

      {address && (
        <>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-4 mb-8">
            <button
              onClick={refreshHistory}
              disabled={isLoading}
              className="btn-outline flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
              title="Refresh transaction history"
            >
              <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
              <span>Refresh</span>
            </button>
          </div>

          <div className="mt-8">
            <TransactionHistory
              mintDepositAddresses={mintDepositAddresses}
              burnHistory={burnHistory}
              isLoading={isLoading}
              network={selectedNetwork}
            />
          </div>
        </>
      )}

      {!address && (
        <div className="text-center py-16">
          <div className="w-16 h-16 mx-auto mb-4 bg-dark-700 rounded-full flex items-center justify-center border border-dark-600">
            <svg className="w-8 h-8 text-dark-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-dark-100 mb-2">Connect Your Wallet</h3>
          <p className="text-dark-400">
            Connect your wallet to view your transaction history
          </p>
        </div>
      )}
    </div>
  );
}